import React from "react";
import { Card } from "antd";
import WebsiteHeader from "../Components/WebsiteHeader";
import WebsiteFooter from "../Components/WebsiteFooter";

export default function LegalPage({ title, subtitle, sections }) {
  return (
    <div className="bg-[#fbfaff] min-h-screen">
      <WebsiteHeader />

      <main className="max-w-[1000px] mx-auto px-4 py-12">
        <div className="text-center mb-10">
          <h1 className="text-4xl font-extrabold">{title}</h1>
          <p className="text-slate-600 mt-3">{subtitle}</p>
        </div>

        <Card className="rounded-3xl shadow-sm">
          <div className="space-y-8">
            {sections.map((item, index) => (
              <div key={index}>
                <h2 className="text-xl font-bold text-purple-700">
                  {item.heading}
                </h2>
                <p className="text-slate-600 leading-7 whitespace-pre-line">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </Card>
      </main>

      <WebsiteFooter />
    </div>
  );
}